import { useQuery } from 'react-query';
import { useAPI } from '@axo/shared/data-access/provider';
import { ace_api } from '@axo/shared/data-access/api';
import { ace } from '@axo/shared/data-access/types';
import { bucketsKeys } from '../../cache-keys/bucketsKeys';
import { queryFunction } from '../../query-function';

export function useBuckets(marketCountry: string) {
  const api = useAPI();

  return useQuery({
    queryKey: [bucketsKeys.buckets(marketCountry)],
    queryFn: queryFunction(
      ace_api.listBuckets(api),
      ({ queryKey: [{ marketCountry }] }) => ({ country: marketCountry }),
    ),
    select: (data: ace.ListBucketsRes) =>
      (data?.Items ?? []).sort((a, b) => (a.Priority < b.Priority ? -1 : 1)),
    enabled: api.token !== '' && marketCountry !== '',
  });
}
